import React, { useEffect, useState } from 'react'
import { Button, Typography, Paper, IconButton, Modal, Box, LinearProgress, Menu, MenuItem } from '@mui/material';
import Grid from "@mui/material/Grid2";
import { useParams, useLocation } from "react-router-dom";
import "./operationsStyles.scss";
import { getOperationsAdvanceReport } from 'src/shared/util/requestDataServer';
import { WrapMain } from 'src/shared/modules/wrap_main';
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { downloadExcelForOperations } from 'src/shared/util/downloadExcel';

export interface SummaryCardDetails {
  id: string;
  label: string;
  value: number | string;
  maxValue: number | string;
  group: string;
}

export interface SummaryCardDto {
  title: string;
  showDetails: boolean;
  downloadOptions: string[]
  value: number;
  maxValue: number;
  detailGroup: string[];
  details: SummaryCardDetails[];
}


export const OperationsSummaryCards = () => {

  const { startDate, endDate, type } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const locations = searchParams.get('locations') || '';

  const [loading, setLoading] = useState(false)

  const [summaryCards, setSummaryCards] = useState<SummaryCardDto[]>([])

  const [activeCard, setActiveCard] = useState<SummaryCardDto | null>(null)

  const [listOfActivities, setListOfActivities] = useState<any[]>([])

  const [openActivitiesModal, setOpenActivitiesModal] = useState(true)
  const [columns, setColumns] = useState<GridColDef[]>([])

  const [anchorRight, setAnchorRight] = useState<null | HTMLElement>(null);
  const openRight = Boolean(anchorRight);

  const [anchorLeft, setAnchorLeft] = useState<null | HTMLElement>(null);
  const openLeft = Boolean(anchorLeft);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true)
    getOperationsAdvanceReport(startDate!, endDate!, type!, "summaryCards", locations)
      .then(response => {
        if (response?.responseStatus) {
          setSummaryCards(response.data);
        } else {
          Swal.fire({
            title: "Error",
            html: response?.data.message || "No se recibieron datos válidos",
            icon: "error",
            confirmButtonText: "Aceptar",
          })
          navigate(`/gto/dashboard/4`);
        }
      })
      .catch(error => {
        console.error("Error al obtener datos:", error);
      })
      .finally(() => {
        setLoading(false);
      });

    if (type === "Requerimientos") {
      setColumns([
        // { field: "optimizationActivityId", headerName: "id", width:10 },
        { field: "requiredDate", headerName: "Fecha de Solictud", minWidth: 150, flex: 1 },
        { field: "executionDate", headerName: "Fecha de Ejecutado", minWidth: 150, flex: 1 },
        { field: "locationName", headerName: "Locación", minWidth: 150, flex: 1 },
        { field: "zone", headerName: "Sector", minWidth: 100, flex: 1 },
        { field: "method", headerName: "Metodo", minWidth: 100, flex: 1 },
        { field: "pot", headerName: "Pot", minWidth: 100, flex: 1 },
        { field: "requesterUserName", headerName: "Requerido Por", minWidth: 150, flex: 1 },
        { field: "variableName", headerName: "Accion", minWidth: 150, flex: 1 },
        { field: "state", headerName: "Estado", minWidth: 150, flex: 1 },
        { field: "comments", headerName: "Comentario", minWidth: 150, flex: 1 },
        { field: "blocker", headerName: "Bloqueantes", minWidth: 150, flex: 1 },
        { field: "priority", headerName: "Prioridad", minWidth: 150, flex: 1 },
        { field: "priorityReason", headerName: "Razón de Prioridad", minWidth: 150, flex: 1 },
        { field: "priorityExtraReason", headerName: "Razón de Prioridad Extra", minWidth: 150, flex: 1 },
      ])
    } else if (type === "Rendimientos") {
      setColumns([
        { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
        { field: "locacion", headerName: "Locación", minWidth: 150, flex: 1 },
        { field: "metodo", headerName: "Metodo", minWidth: 100, flex: 1 },
        { field: "pot", headerName: "Pot", minWidth: 100, flex: 1 },
        { field: "horaEntrada", headerName: "Hora Inicio Act.", minWidth: 150, flex: 1 },
        { field: "horaSalida", headerName: "Hora Fin Act.", minWidth: 150, flex: 1 },
        { field: "sector", headerName: "Sector", minWidth: 100, flex: 1 },
        { field: "cuadrilla", headerName: "Cuadrilla", minWidth: 100, flex: 1 },
        { field: "ingenieros", headerName: "Ingenieros", minWidth: 200, flex: 1 },
        { field: "campo", headerName: "Campo", minWidth: 120, flex: 1 },
        { field: "tecnologia", headerName: "Tecnología", minWidth: 150, flex: 1 },
        { field: "tipoActividad", headerName: "Tipo Actividad", minWidth: 150, flex: 1 },
        { field: "estadoInicialAct", headerName: "Estado Inicial Act.", minWidth: 150, flex: 1 },
        { field: "estadoFinalAct", headerName: "Estado Final Act.", minWidth: 150, flex: 1 },
        { field: "thp", headerName: "THP", minWidth: 150, flex: 1 },
        { field: "marcaBalancin", headerName: "Marca Balancín", minWidth: 150, flex: 1 },
        { field: "modeloBalancin", headerName: "Modelo Balancín", minWidth: 150, flex: 1 },
        { field: "barraLibre", headerName: "Barra Libre", minWidth: 150, flex: 1 },
        { field: "carrera", headerName: "Carrera", minWidth: 150, flex: 1 },
        { field: "spm", headerName: "SPM", minWidth: 150, flex: 1 },
        { field: "rpm", headerName: "RPM", minWidth: 150, flex: 1 },
        { field: "tiro", headerName: "Tiro", minWidth: 150, flex: 1 },
        { field: "cargaMax", headerName: "Carga_max", minWidth: 150, flex: 1 },
        { field: "cargaMin", headerName: "Carga_min", minWidth: 150, flex: 1 },
        { field: "nivelPies", headerName: "Nivel (pies)", minWidth: 150, flex: 1 },
        { field: "sumergenciaPies", headerName: "Sumergencia (pies)", minWidth: 150, flex: 1 },
        { field: "pipLpc", headerName: "PIP (lpc)", minWidth: 150, flex: 1 },
        { field: "pwfLpc", headerName: "Pwf (lpc)", minWidth: 150, flex: 1 },
        { field: "velocidadAcustica", headerName: "Velocidad Acústica", minWidth: 150, flex: 1 },
        { field: "comentarioCampo", headerName: "Comentario Campo", minWidth: 200, flex: 1 },
        { field: "condMaleza", headerName: "Cond. Maleza", minWidth: 120, flex: 1 },
        { field: "condFosa", headerName: "Cond. Fosa", minWidth: 150, flex: 1 },
        { field: "estatusStuffing", headerName: "Estatus Stuffing", minWidth: 150, flex: 1 },
        { field: "estatusSonolog", headerName: "Estatus Sonolog", minWidth: 150, flex: 1 },
        { field: "estatusValvula2da4", headerName: "Estatus Válvula 2da 4\"", minWidth: 180, flex: 1 },
        { field: "estatusValvMuestra", headerName: "Estatus Válv. Muestra", minWidth: 180, flex: 1 },
        { field: "estatusFrenos", headerName: "Estatus Frenos", minWidth: 120, flex: 1 },
        { field: "estatusSelector", headerName: "Estatus Selector", minWidth: 150, flex: 1 },
        { field: "accesoVareador", headerName: "Acceso Vareador", minWidth: 150, flex: 1 },
        { field: "accesoCabezal", headerName: "Acceso Cabezal", minWidth: 150, flex: 1 },
        { field: "pozoReespaciado", headerName: "Pozo Reespaciado", minWidth: 150, flex: 1, type: 'boolean' },
        { field: "eptAnteriorIn", headerName: "EPT (Anterior-In)", minWidth: 150, flex: 1 },
        { field: "eptPosteriorIn", headerName: "EPT (Posterior-In)", minWidth: 150, flex: 1 },
        { field: "carta", headerName: "Carta", minWidth: 180, flex: 1, type: 'boolean' },
        { field: "nivel", headerName: "Nivel", minWidth: 180, flex: 1, type: 'boolean' },
        { field: "pruebaPresion", headerName: "Prueba Presión", minWidth: 150, flex: 1, type: 'boolean' },
        { field: "pruebaValvula", headerName: "Prueba Válvula", minWidth: 150, flex: 1, type: 'boolean' },
        { field: "muestrasTomadas", headerName: "Muestras Tomadas", minWidth: 150, flex: 1, type: 'boolean' },
        { field: "fechaAnalisis", headerName: "Fecha Análisis", minWidth: 150, flex: 1 },
        { field: "horaAnalisis", headerName: "Hora Análisis", minWidth: 150, flex: 1 },
        { field: "estado", headerName: "Estado", minWidth: 150, flex: 1 },
        { field: "analizadoPor", headerName: "Analizado Por", minWidth: 150, flex: 1 },
        { field: "diagnostico", headerName: "Diagnóstico", minWidth: 200, flex: 1 },
        { field: "recomendacion", headerName: "Recomendación", minWidth: 200, flex: 1 },
        { field: "estatusCandidato", headerName: "Estatus Candidato", minWidth: 150, flex: 1 },
        { field: "condicionFondo", headerName: "Condición de Fondo", minWidth: 180, flex: 1 },
        { field: "subCondicionFondo", headerName: "Sub-Condición Fondo", minWidth: 180, flex: 1 },
        { field: "llenadoFondoPorcentaje", headerName: "Llenado Fondo (%)", minWidth: 150, flex: 1, type: 'number' },
        { field: "diametroPiston", headerName: "Diámetro Pistón", minWidth: 150, flex: 1, type: 'number' },
        { field: "analisisEpt", headerName: "Análisis EPT", minWidth: 150, flex: 1, type: 'number' },
        { field: "produccionTeorica", headerName: "Producción Teórica", minWidth: 180, flex: 1, type: 'number' },
        { field: "eficienciaBombaPorcentaje", headerName: "Eficiencia Bomba (%)", minWidth: 180, flex: 1, type: 'number' },
        { field: "prodTeoricaConEficiencia", headerName: "Prod. Teórica (c/Eficiencia)", minWidth: 200, flex: 1, type: 'number' },
        { field: "actividadOptimizacion", headerName: "Actividad de Optimizacion", minWidth: 200, flex: 1 },
        { field: "esCbo", headerName: "Es CBO", minWidth: 200, flex: 1, type: 'boolean' },
        { field: "simulado", headerName: "Simulado", minWidth: 90, flex: 1, type: 'boolean' },
        { field: "repetitivoTds", headerName: "Repetitivo TDS", minWidth: 90, flex: 1, type: 'boolean' }
      ])
    } else if (type === "Opciones de Optimizacion") {
      setColumns([
        // { field: "optimizationActivityId", headerName: "id", width:10 },
        { field: "requiredDate", headerName: "Fecha de Solicitud", minWidth: 150, flex: 1 },
        { field: "executionDate", headerName: "Fecha de Ejecutado", minWidth: 150, flex: 1 },
        { field: "locationName", headerName: "Locación", minWidth: 150, flex: 1 },
        { field: "zone", headerName: "Sector", minWidth: 100, flex: 1 },
        { field: "method", headerName: "Metodo", minWidth: 100, flex: 1 },
        { field: "pot", headerName: "Pot", minWidth: 100, flex: 1 },
        { field: "requesterUserName", headerName: "Requerido Por", minWidth: 150, flex: 1 },
        { field: "variableName", headerName: "Accion", minWidth: 150, flex: 1 },
        { field: "isCBO", headerName: "EsCBO", minWidth: 150, flex: 1 },
        { field: "isWellWithMultiplesTDSEntries", headerName: "Repetitivo TDS", minWidth: 150, flex: 1 },
        { field: "state", headerName: "Estado", minWidth: 150, flex: 1 },
        { field: "comments", headerName: "Comentario", minWidth: 150, flex: 1 },
        { field: "simulationDate", headerName: "Fecha Simulado", minWidth: 150, flex: 1 },
        { field: "productionBefore", headerName: "Pot Antes", minWidth: 100, flex: 1 },
        { field: "expectedProduction", headerName: "Pot Esperada", minWidth: 100, flex: 1 }
      ])
    }

  }, [startDate, endDate, type])

  useEffect(() => {
    if (listOfActivities.length > 0) {
      setOpenActivitiesModal(true);
    } else {
      setOpenActivitiesModal(false);
    }
  }, [listOfActivities])



  const downloadExcel = () => {
    setLoading(true)
    setAnchorRight(null)
    setListOfActivities([])
    downloadExcelForOperations(startDate!, endDate!, type!, "excel", locations).finally(() => setLoading(false));
  }

  const viewListOfActivities = () => {
    setLoading(true)
    setAnchorRight(null)
    getOperationsAdvanceReport(startDate!, endDate!, type!, "activitiesList", locations)
      .then(response => {
        if (response?.responseStatus) {
          setListOfActivities(response.data);
        } else {
          Swal.fire({
            title: "Error",
            html: response?.data.message || "No se recibieron datos válidos",
            icon: "error",
            confirmButtonText: "Aceptar",
          })
        }
      })
      .catch(error => {
        console.error("Error al obtener datos:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const viewListOfOptimizationActivities = () => {
    navigate(`/gto/list_of_optimizations/${encodeURIComponent(startDate!)}/${encodeURIComponent(endDate!)}`);
  }

  const defaultRenderCell = (params: any) => {
    let displayValue = params.value;

    // Check for date (ISO string or Date object)
    if (
      displayValue &&
      (
        (typeof displayValue === 'string' && moment(displayValue, moment.ISO_8601, true).isValid()) ||
        displayValue instanceof Date
      )
    ) {
      // Format as DD-MM-YYYY
      displayValue = moment(displayValue).format('DD-MM-YYYY');
    }
    // Check for number with decimals
    else if (typeof displayValue === 'number') {
      if (!Number.isInteger(displayValue)) {
        displayValue = displayValue.toFixed(2);
      }
    }

    return (
      <Box sx={{ height: "100%", display: "flex", alignItems: "center" }}>
        <Typography
          sx={{
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
            py: "5px",
            px: "2px",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
          }}
        >
          {displayValue ?? ""}
        </Typography>
      </Box>
    );
  };

  const downloadExcelEditTemplate = () => {
    setLoading(true)
    setAnchorRight(null)
    setListOfActivities([])
    downloadExcelForOperations(startDate!, endDate!, type!, "excelTemplate", locations).finally(() => setLoading(false));
  }

  const editTemplate = () => {
    navigate(`/gto/upload/well_files?id=rendimiento`);
  }

  return (
    <WrapMain>
      {loading && (
        <>
          <Box className="modal_analyst_loading_background" />
          <Box className="modal__analyst_task_loading">
            <LinearProgress />
            Consultando....
          </Box>
        </>
      )}
      {/* Modal de Lista de actividades */}

      <Modal
        open={openActivitiesModal}
        onClose={() => setListOfActivities([])}
      >
        <Box className="modal-list-activities">
          <Box className="modal_header">
            <IconButton
              aria-label="delete"
              size='small'
              onClick={() => setListOfActivities([])}
            >
              <CloseIcon color="error" />
            </IconButton>
            <Typography className='title' id="modal-modal-title" variant="h6" component="h2">
              Lista de Actividades
            </Typography>
            <IconButton
              aria-label="delete"
              size='small'
              onClick={() => downloadExcel()}
            >
              <FileDownloadIcon color="info" />
            </IconButton>
          </Box>
          {/* <Grid> */}
          <DataGrid
            rows={listOfActivities}
            columns={columns.map((col, idx) => ({
              ...col,
              // disableColumnMenu: true,
              headerAlign: "center",
              renderCell: col.renderCell || defaultRenderCell,
              cellClassName: `custom-col-${idx}`,
              headerClassName: `custom-col-header-${idx}`,
            }))}
            pageSizeOptions={[10, 20, 50, 100]}
            checkboxSelection={false}
            sx={{
              border: 0,
              height: {
                md: `calc(100vh - 130px)`,
                lg: `calc(100vh - 130px)`,
              },
              "& .MuiDataGrid-columnHeaders": {
                borderBottom: "none",
                gap: "8px",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "custom.grey1",
              },
              "& .MuiDataGrid-columnHeader:nth-of-type(even)": {
                backgroundColor: "#f5f7fa", // light grey
              },
              "& .MuiDataGrid-columnHeader:nth-of-type(odd)": {
                backgroundColor: "#e3f0fc", // light blue
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                backgroundColor: "custom.blue2",
                color: "#fff",
                textAlign: "center",
                justifyContent: "center",
                borderRadius: "10px",
                padding: "10px",
                width: "100% !important",
                alignItems: "center",
                whiteSpace: "normal",
              },
              "& .MuiDataGrid-row": {
                borderBottom: (theme) =>
                  `1px solid ${theme.palette.custom.icons}`,
              },
              // Alternating column background colors
              "& .MuiDataGrid-cell": {
                "&:nth-of-type(even)": {
                  backgroundColor: "#f5f7fa", // light grey
                },
                "&:nth-of-type(odd)": {
                  backgroundColor: "#e3f0fc", // light blue
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              },
            }}
            getRowId={(row) => row.locationId}
          />
          {/* </Grid> */}
        </Box>
      </Modal>

      {/* bodyCards */}
      <Grid className="header_summary_cards_container">
        <Grid className="header_summary_cards_screen">
          <IconButton
            size="medium"
            color="primary"
            onClick={(event) => setAnchorLeft(event.currentTarget)}
          >
            <img src="/assets/icons/edit-card.svg" alt='logo' height={25} width={25} />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorLeft}
            open={openLeft}
            onClose={() => setAnchorLeft(null)}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{
              marginTop: "1px",
              border: "1px solid #e0e0e0",
              boxShadow: "0px 4px 16px rgba(0,0,0,0.08)",
            }}
          >
            <MenuItem>
              <Grid className={`sub_menu_operation_summary_menu_header`}>
                <Grid onClick={() => downloadExcelEditTemplate()}>
                  Descargar Plantillas
                </Grid>
              </Grid>
            </MenuItem>
            <MenuItem>
              <Grid className={`sub_menu_operation_summary_menu_header`}>
                <Grid onClick={() => editTemplate()}>
                  Editar Actividades
                </Grid>
              </Grid>
            </MenuItem>
          </Menu>
          <Typography className='text'>
            {type}
          </Typography>
          <IconButton
            size="medium"
            color="primary"
            onClick={(event) => setAnchorRight(event.currentTarget)}
          >
            <img src="/assets/icons/download-sheet.svg" alt='logo' height={25} width={25} />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorRight}
            open={openRight}
            onClose={() => setAnchorRight(null)}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{
              marginTop: "1px",
              border: "1px solid #e0e0e0",
              boxShadow: "0px 4px 16px rgba(0,0,0,0.08)",
            }}
          >
            <MenuItem>
              <Grid className={`sub_menu_operation_summary_menu_header`}>
                <Grid onClick={() => viewListOfOptimizationActivities()}>
                  Ver Propuestas de Subsuelo
                </Grid>
              </Grid>
            </MenuItem>
            <MenuItem>
              <Grid className={`sub_menu_operation_summary_menu_header`}>
                <Grid onClick={() => viewListOfActivities()}>
                  Ver Lista de Actividades
                </Grid>
              </Grid>
            </MenuItem>
            <MenuItem>
              <Grid className={`sub_menu_operation_summary_menu_header`}>
                <Grid onClick={() => downloadExcel()}>
                  Descargar Lista de Activiades
                </Grid>
              </Grid>
            </MenuItem>

          </Menu>
        </Grid>
        {/* Cards */}
        <Grid className="body_summary_cards">
          {summaryCards.map((card, idx) => (
            <Grid key={idx} className="card" sx={{
              height: activeCard?.title === card.title ? 500 : 320,
            }}>
              {/* buttons */}
              <Grid className="button_header">
                {/* {card.showDetails && (
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => { }}
                  >
                    <img
                      src="/assets/icons/lookForBlue.svg"
                      alt="logo"
                      height={17}
                      width={17}
                    />
                  </IconButton>
                )}
                {card.downloadOptions.length > 0 && (
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => { }}
                  >
                    <img src="/assets/icons/download-sheet.svg" alt='logo'
                      height={20} width={20} />
                  </IconButton>
                )} */}
              </Grid>

              {/* card title */}
              <Grid className="title">{card.title}</Grid>
              <Grid className="value">{card.value}</Grid>
              <Grid className="progress-values">
                <Typography>{card.value}</Typography>
                <span>/</span>
                <Typography>{card.maxValue}</Typography>
              </Grid>
              <LinearProgress
                variant="determinate"
                value={
                  card.maxValue && !isNaN(Number(card.value)) && !isNaN(Number(card.maxValue)) && Number(card.maxValue) !== 0
                    ? (Number(card.value) / Number(card.maxValue)) * 100
                    : 100
                }
                sx={{ borderRadius: 5, height: 10, backgroundColor: "#12376" }}
              />
              <Grid>
                <Grid className="detalles_button" onClick={() => setActiveCard(activeCard?.title === card.title ? null : card)}>
                  <Typography>Detalles</Typography>
                  <img src={
                    activeCard?.title === card.title
                      ? "/assets/icons/arrow_down.svg"
                      : "/assets/icons/arrow_up.svg"} alt='logo' height={25} width={25} />
                </Grid>
              </Grid>
              {activeCard?.title === card.title && (
                <Grid className="card_details">
                  {card.detailGroup.map((group, index) => {
                    const filteredDetails = card.details.filter(detail => detail.group === group);
                    return (
                      <Grid key={index} className="detail_group">
                        <Grid className="detail_group_separator">
                          {group}
                        </Grid>
                        {filteredDetails.map((detail, index) => (
                          <Grid key={index} className="detail_element">
                            <Typography className='title_section'>{detail.label}</Typography>
                            <Typography className='value_section'>{detail.value} / {detail.maxValue}</Typography>
                          </Grid>
                        ))}
                      </Grid>
                    );
                  })}
                </Grid>
              )}
            </Grid>
          ))}
        </Grid>
      </Grid>
    </WrapMain>
  );
}
